import React from 'react'

const VideoPlay = () => (
  <svg width="70" height="70" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><circle className="stroke-current" stroke-width="2" cx="35" cy="35" r="34"/><path className="fill-current" d="M42.522 35.022l-14.044 9.5v-19z"/></g></svg>
)

export default VideoPlay
